module.exports = __webpack_public_path__ + "img/success.0ce34958.svg";